import { About } from 'src/presentation/pages'

export const makeAbout = () => <About />
